// /* eslint-disable */
import React, { useEffect } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import colors from "./assets/ts/colors";
import AppRoutes from "./routes/Routes";
import { requestFCMToken } from "./firebase/firebase-config";
import ScrollToTop from "./components/common/ScrollToTop";
import AnalyticsTracker from "./components/common/AnalyticsTracker";

const App: React.FC = () => {
  useEffect(() => {
    requestFCMToken();
    // Set CSS custom properties (variables)
    Object.keys(colors).forEach((key) => {
      document.documentElement.style.setProperty(
        `--${key}`,
        colors[key as keyof typeof colors]
      );
    });
  }, []);
  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      {/* Single instance for the whole app — call PrimeReact's imperative
          confirmDialog({ message, accept, reject }) from anywhere instead of
          the native window.confirm/alert popups. */}
      <ConfirmDialog />
      <AppRoutes />
    </>
  );
};

export default App;

